export const getInstanceIdFromDocumentDomElement = (element: HTMLElement) =>
  element?.dataset?.instanceId;

export const searchForVariationElement = (domElement: HTMLElement | null): HTMLElement | null => {
  if (domElement == null) {
    return null;
  }
  if (domElement.dataset?.variation != null) {
    return domElement;
  }

  return searchForVariationElement(domElement.parentElement);
};
